import { Admission, ADMISSION_TYPE_BOTTLE_SERVICE, ADMISSION_TYPE_TICKET } from '@domain/admission';
import { EventListItemSettings, EventSettings } from '@domain/event';
import { AdmissionResponse } from '@hooks/admissions/use-get-admissions';

type CheckSiaeAdmissionType = typeof ADMISSION_TYPE_BOTTLE_SERVICE | typeof ADMISSION_TYPE_TICKET;
const CheckSiaeAdmissionTypes = [ADMISSION_TYPE_BOTTLE_SERVICE, ADMISSION_TYPE_TICKET];

export const checkIsSiaeOfferInReview = (
  admission?: Admission | null,
  settings?: EventSettings | EventListItemSettings
) => {
  if (!!settings && !settings?.isPublished) return false;
  const isTicketOrBottleService =
    admission?.admissionType && CheckSiaeAdmissionTypes.includes(admission?.admissionType);
  return (
    !!admission?.settings?.italyRegulation &&
    !admission?.settings.italyRegulation?.isSiaeApproved &&
    !admission?.settings.italyRegulation?.isSiaeExcluded &&
    isTicketOrBottleService &&
    admission.price.amount > 0
  );
};

const hasOneSiaeAdmissionInReview = (
  eventSettings: EventSettings | EventListItemSettings,
  admissions?: AdmissionResponse
) => {
  return (
    !!admissions &&
    (CheckSiaeAdmissionTypes as Array<CheckSiaeAdmissionType>).some((admissionType) =>
      admissions[admissionType].some((admission) => checkIsSiaeOfferInReview(admission, eventSettings))
    )
  );
};

export const checkIsSiaeEventInReview = (
  eventSettings: EventSettings | EventListItemSettings,
  admissions?: AdmissionResponse
) => {
  return (
    eventSettings.isPublished &&
    eventSettings.italyRegulation.isSIAE &&
    eventSettings.italyRegulation.alligatorId === null &&
    hasOneSiaeAdmissionInReview(eventSettings, admissions)
  );
};

const hasSiaeOfferSellingOnline = (admissions?: AdmissionResponse) => {
  return (
    !!admissions &&
    (CheckSiaeAdmissionTypes as Array<CheckSiaeAdmissionType>).some((admissionType) =>
      admissions[admissionType].some(
        (admission) => !admission.settings?.italyRegulation?.isSiaeExcluded && admission.onlinePaymentPercentage > 0
      )
    )
  );
};

export const checkShowSiaeOnlinePaymentAlert = (
  eventSettings: EventSettings | EventListItemSettings,
  admissions?: AdmissionResponse
) => {
  return eventSettings.italyRegulation.isSIAE && hasSiaeOfferSellingOnline(admissions);
};

// '' / '0' / null all mean "not set"; real codes are >= 1.
export const hasSiaeEventCode = (eventSettings: EventSettings | EventListItemSettings) => {
  return Number(eventSettings.italyRegulation.SIAEGenre) > 0;
};

// Like the alert, but hidden once the code is set; validation still uses the alert.
export const checkShowSiaeOnlinePaymentWarning = (
  eventSettings: EventSettings | EventListItemSettings,
  admissions?: AdmissionResponse
) => {
  return checkShowSiaeOnlinePaymentAlert(eventSettings, admissions) && !hasSiaeEventCode(eventSettings);
};
